import React from 'react';
import loading from './loading.gif';

const ImportSpinner = () => (
    <div>
        <span className="Loader">
            <div className="Loader-indicator">
                <h1>
                    <img id="spinner_img" src={loading} />
                    <span id="pleaseWaitLoader">Importing Data, Please Wait....</span>
                </h1>
            </div>
        </span>
    </div>
);

export default ImportSpinner;